import axios from "axios";

const BE_URL = process.env.REACT_APP_BE_URL;

// (registerSupporter removed — it POSTed to the old unauthenticated register
// route, which let a signup skip email verification. Supporters are created only
// by confirmSignup below, via the magic link.)

// need to do a series of calls, one for each level and get supporter totals.
export const supporterNumber = async ({ nation, state, county, precinct }) => {
  const urlNation = `${BE_URL}/api/total/supporters/${nation}`;
  const urlState = `${BE_URL}/api/total/supporters/${nation}/${state}`;
  const urlCounty = `${BE_URL}/api/total/supporters/${nation}/${state}/${county}`;
  const urlPrecinct = `${BE_URL}/api/total/supporters/${nation}/${state}/${county}/${precinct}`;
  try {
    const responseNation = await axios.get(urlNation);
    const responseState = await axios.get(urlState);
    const responseCounty = await axios.get(urlCounty);
    const responsePrecinct = await axios.get(urlPrecinct);
    const nationNum = Math.floor(responseNation.data.headSupportTotal);
    const stateNum = Math.floor(responseState.data.headSupportTotal);
    const countyNum = Math.floor(responseCounty.data.headSupportTotal);
    const precinctNum = Math.floor(responsePrecinct.data.headSupportTotal);
    const movement = "MaxVoting";
    const movementHash = "#MaxVoting";
    const mission =
      "spread an understanding of the power of MaxVoting, in all of its forms, to solve our current crisis of toxic political division, and to coordinate the submission of MaxVoting legislation in every state.";

    const levelValues = [
      [
        nationNum / responseNation.data.headVoteTotal,
        (nationNum - 1.0) / responseNation.data.headVoteTotal,
      ],
      [
        stateNum / responseState.data.headVoteTotal,
        (stateNum - 1.0) / responseState.data.headVoteTotal,
      ],
      [
        countyNum / responseCounty.data.headVoteTotal,
        (countyNum - 1.0) / responseCounty.data.headVoteTotal,
      ],
      [
        precinctNum / responsePrecinct.data.headVoteTotal,
        (precinctNum - 1.0) / responsePrecinct.data.headVoteTotal,
      ],
    ];

    return {
      nationNum,
      stateNum,
      countyNum,
      precinctNum,
      movement,
      mission,
      levelValues,
      responseNation,
      responseState,
      responseCounty,
      responsePrecinct,
      movementHash,
    };
  } catch (e) {
    return { error: (e.response && e.response.data) || e.message };
  }
};

// Passwordless signup (#2): send the signup, backend emails a one-click link.
// No supporter is created until the link is clicked (confirmSignup).
// confirmBase = this origin so the emailed link returns to the same site
// (localhost in dev, swarmage.net in prod); the backend allowlists it.
export const signupSupporter = async ({
  userName,
  email,
  state,
  county,
  precinct,
  coreSupporter,
}) => {
  const url = `${BE_URL}/api/supporters/supporters/signup`;
  try {
    const response = await axios.post(url, {
      userName,
      email,
      state,
      county,
      precinct,
      coreSupporter,
      confirmBase: window.location.origin,
    });
    return { data: response.data };
  } catch (e) {
    return { error: (e.response && e.response.data) || e.message };
  }
};

// The /confirm page calls this with the token from the magic link.
export const confirmSignup = async (token) => {
  const url = `${BE_URL}/api/supporters/supporters/confirm`;
  try {
    const response = await axios.post(url, { token });
    return { data: response.data };
  } catch (e) {
    return { error: (e.response && e.response.data) || e.message };
  }
};

// Passwordless "manage / remove my support": email a one-click link, then the
// /revoke page confirms the removal.
export const requestRevoke = async (email) => {
  const url = `${BE_URL}/api/supporters/supporters/revoke-request`;
  try {
    const response = await axios.post(url, {
      email,
      confirmBase: window.location.origin,
    });
    return { data: response.data };
  } catch (e) {
    return { error: (e.response && e.response.data) || e.message };
  }
};

export const confirmRevoke = async (token) => {
  const url = `${BE_URL}/api/supporters/supporters/revoke-confirm`;
  try {
    const response = await axios.post(url, { token });
    return { data: response.data };
  } catch (e) {
    return { error: (e.response && e.response.data) || e.message };
  }
};

// Public certificate check for /verify/:certCode. Returns the same details the
// certificate itself prints (name, county, state, join date) — never the email.
export const verifyCertificate = async (certCode) => {
  const url = `${BE_URL}/api/supporters/supporters/verify/${encodeURIComponent(
    certCode
  )}`;
  try {
    const response = await axios.get(url);
    return { data: response.data };
  } catch (e) {
    const status = e.response && e.response.status;
    return { error: status === 404 ? "notfound" : status === 400 ? "malformed" : "network" };
  }
};

// (sendVerificationEmail, verifyCode and forgottenPassword removed — they called
// /verify-email, /verify-code and /forgotten-password, all of which were deleted
// from the backend when signup went passwordless.)
